import _Message from "@arco-design/web-react/es/Message";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var StepHistory = function () {
  function StepHistory() {
    this.stack = [];
    this.guide = -1;
  }
  StepHistory.prototype.add = function (item) {
    if (this.guide === this.stack.length - 1) {
      this.stack.push(item);
      this.guide++;
    } else {
      this.guide++;
      this.stack = this.stack.slice(0, this.guide).concat(item);
    }
  };
  StepHistory.prototype.back = function () {
    if (this.canBack()) {
      var applyItem = this.stack[this.guide--];
      if (applyItem) {
        var tokens_1 = {};
        Object.values(applyItem).map(function (item) {
          tokens_1[item.key] = __assign(__assign({}, item), {
            value: item.prevValue,
            prevValue: item.value
          });
        });
        return tokens_1;
      }
    }
    return null;
  };
  StepHistory.prototype.forward = function () {
    if (this.canForward()) {
      this.guide++;
      var applyItem = this.stack[this.guide];
      return applyItem;
    }
    return null;
  };
  StepHistory.prototype.clear = function () {
    this.stack = [];
    this.guide = -1;
  };
  StepHistory.prototype.canBack = function () {
    return this.guide > -1;
  };
  StepHistory.prototype.canForward = function () {
    return this.guide < this.stack.length - 1;
  };
  return StepHistory;
}();
var History = function () {
  function History() {
    this.steps = {};
  }
  History.prototype.add = function (item) {
    var _this = this;
    var obj = {};
    Object.values(item).map(function (ele) {
      if (!obj[ele.component]) {
        obj[ele.component] = {};
      }
      obj[ele.component][ele.key] = ele;
    });
    Object.keys(obj).map(function (key) {
      var step = _this.steps[key];
      if (!step) {
        step = new StepHistory();
        _this.steps[key] = step;
      }
      step.add(obj[key]);
    });
  };
  History.prototype.getHistory = function (component) {
    return this.steps[component] || new StepHistory();
  };
  History.prototype.back = function (component) {
    var step = this.steps[component];
    if (step) {
      return step.back();
    }
    _Message.info('无法撤回');
  };
  History.prototype.forward = function (component) {
    var step = this.steps[component];
    if (step) {
      return step.forward();
    }
  };
  History.prototype.clear = function (component) {
    var step = this.steps[component];
    if (step) {
      step.clear();
    }
  };
  History.prototype.canBack = function (component) {
    var step = this.steps[component];
    return step && step.canBack();
  };
  History.prototype.canForward = function (component) {
    var step = this.steps[component];
    return step && step.canForward();
  };
  return History;
}();
export default History;